module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-up-left-4.77300f21.png";